import type { AssetApi } from "@skilitics/assets";
import { AssetApiProvider } from "@skilitics/assets";
import { ModalDialogContextProvider } from "@skilitics/designer-ui-components";

import { type NautilusApi, NautilusApiContextProvider, useBackendApi } from "../backend";
import { NodeTransientStateProvider } from "../transientState/NodeTransientStateProvider";
import type {
  FindDefinitions,
  GetManifestByTypeId,
  GetMigrateFromManifestByTypeId,
  GetPlaceholderManifest,
} from "../types";
import type { GetValueSubtypeDefinition } from "../values";
import { NodeDesignsWithBackendProvider } from "./NodeDesignsWithBackend";
import type { RootNodeSettings } from "./persistence";
import { RootNodeDesigner } from "./RootNodeDesigner";

type NautilusProps = {
  hostId: string;
  api: NautilusApi;
  assetApi: AssetApi;
  findDefinitions: FindDefinitions;
  getManifest: GetManifestByTypeId;
  getPlaceholderManifest: GetPlaceholderManifest;
  getMigrateFromManifest: GetMigrateFromManifestByTypeId;
  getValueSubtypeDefinition: GetValueSubtypeDefinition;
  rootNodeSettings: RootNodeSettings;
};

export const NautilusHost = ({
  hostId,
  api,
  assetApi,
  findDefinitions,
  getManifest,
  getMigrateFromManifest,
  getPlaceholderManifest,
  getValueSubtypeDefinition,
  rootNodeSettings,
}: NautilusProps) => {
  const backendApi = useBackendApi({ hostId, api });
  return (
    <NodeTransientStateProvider>
      <NautilusApiContextProvider api={api} hostId={hostId}>
        <NodeDesignsWithBackendProvider
          api={backendApi}
          getManifest={getManifest}
          getMigrateFromManifest={getMigrateFromManifest}
          getPlaceholderManifest={getPlaceholderManifest}
          getValueSubtypeDefinition={getValueSubtypeDefinition}
          rootNodeSettings={rootNodeSettings}
        >
          <AssetApiProvider api={assetApi}>
            <ModalDialogContextProvider>
              <RootNodeDesigner findDefinitions={findDefinitions} />
            </ModalDialogContextProvider>
          </AssetApiProvider>
        </NodeDesignsWithBackendProvider>
      </NautilusApiContextProvider>
    </NodeTransientStateProvider>
  );
};
